// src/Components/Tournaments/EventForm.jsx
import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { useAuth } from "../../Context/AuthContext";
import { toast } from "react-toastify";
import { IoHome } from "react-icons/io5";
import { PiKeyReturnFill } from "react-icons/pi";
import "./AddEventForm.css";

const API = process.env.REACT_APP_API;

const EventForm = ({ mode }) => {
  const { slug, eventId } = useParams();
  const navigate = useNavigate();
  const { token } = useAuth();

  const checkboxes = [
    { label: "מוצג באתר", name: "showOnSite" },
    { label: "פלייר", name: "showFlyer" },
    { label: "כפתור הרשמה", name: "showRegistration" },
    { label: "כפתור פייסבוק", name: "showFacebook" },
    { label: "גלרייה", name: "showGallery" },
  ];

  const [form, setForm] = useState({
    name: "",
    startDate: "",
    endDate: "",
    registrationLink: "",
    facebookLink: "",
    showOnSite: true,
    showFlyer: true,
    showRegistration: true,
    showFacebook: true,
    showGallery: true,
  });

  const [flyerFile, setFlyerFile] = useState(null);
  const [flyerPreview, setFlyerPreview] = useState(null);
  const [gallery, setGallery] = useState([]);

  // 🔹 טעינה במצב עריכה
  useEffect(() => {
    if (mode === "edit") {
      axios.get(`${API}/api/tournaments/slug/${slug}`).then(res => {
        const ev = res.data.events.find(e => e._id === eventId);
        if (!ev) return;

        setForm({
          name: ev.name || "",
          startDate: ev.startDate ? ev.startDate.split("T")[0] : "",
          endDate: ev.endDate ? ev.endDate.split("T")[0] : "",
          registrationLink: ev.registrationLink || "",
          facebookLink: ev.facebookLink || "",
          showOnSite: ev.showOnSite ?? true,
          showFlyer: ev.showFlyer ?? true,
          showRegistration: ev.showRegistration ?? true,
          showFacebook: ev.showFacebook ?? true,
          showGallery: ev.showGallery ?? true,
        });

        if (ev.flyer) setFlyerPreview(ev.flyer);
        if (ev.gallery?.length) {
          setGallery(ev.gallery.map(src => ({ src })));
        }
      });
    }
  }, [mode, slug, eventId]);

  const handleChange = e => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  const toggleCheckbox = async (name) => {
    const newValue = !form[name];
    const updatedForm = { ...form, [name]: newValue };
    setForm(updatedForm); // עדכון מקומי

    if (mode === "edit") {
      try {
        await axios.put(
          `${API}/api/tournaments/slug/${slug}/events/${eventId}`,
          updatedForm,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
        if (!newValue)
          toast.success(`${checkboxes.find(c => c.name === name).label} מוסתר/ת באתר`);
        else
          toast.success(`${checkboxes.find(c => c.name === name).label} מוצג/ת באתר`);          
          // toast.success(`${checkboxes.find(c => c.name === name).label} עודכן בהצלחה`);
      } catch (err) {
        console.error(err);
        toast.error("❌ עדכון נכשל");
        setForm(prev => ({ ...prev, [name]: !newValue })); // ביטול שינוי במידה ושגיאה
      }
    }
  };

  const onFlyerChange = e => {
    const file = e.target.files[0];
    setFlyerFile(file || null);
    setFlyerPreview(file ? URL.createObjectURL(file) : flyerPreview);
  };

  const onGalleryChange = e => {
    const files = Array.from(e.target.files || []);
    const items = files.map(f => ({
      file: f,
      src: URL.createObjectURL(f),
    }));
    setGallery(prev => [...prev, ...items]);
  };

  const removeGalleryItem = index => {
    setGallery(prev => prev.filter((_, i) => i !== index));
  };

  const handleSubmit = async e => {
    e.preventDefault();

    const formData = new FormData();
    Object.entries(form).forEach(([k, v]) => formData.append(k, v));

    if (flyerFile) formData.append("flyer", flyerFile);
    gallery.filter(g => g.file).forEach(g => formData.append("gallery", g.file));

    // ⭐ שולחים לשרת אילו תמונות נשארו
  const keepUrls = gallery
    .filter(g => !g.file) // רק תמונות קיימות
    .map(g => g.src);

  formData.append("galleryToKeep", JSON.stringify(keepUrls));

    try {
      if (mode === "create") {
        await axios.post(
          `${API}/api/tournaments/slug/${slug}/events`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "multipart/form-data",
            },
          }
        );
      } else {
        await axios.put(
          `${API}/api/tournaments/slug/${slug}/events/${eventId}`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "multipart/form-data",
            },
          }
        );
      }

      toast.success("✅ האירוע נשמר בהצלחה");
      navigate(`/tournaments/${slug}`);
    } catch (err) {
        console.error(err);
        toast.error("❌ שגיאה בשמירה");
    }
  };
  
  // מחיקה
  const handleDelete = async () => {
      if (!window.confirm("את/ה בטוח/ה שברצונך למחוק את האירוע?")) return;

      try {
          await axios.delete(`${API}/api/tournaments/slug/${slug}/events/${eventId}`, {
              headers: { Authorization: `Bearer ${token}` },
          });
          toast.success('❌ האירוע נמחק בהצלחה');
          navigate(`/tournaments/${slug}`);
      } catch (err) {
          console.error("שגיאה במחיקת האירוע:", err);
          toast.error('❌ מחיקת האירוע נכשלה');
      }
  };

  return (
    <div className="event-form card">
      <div className="home-icon">
        <IoHome size={30} onClick={() => navigate("/")} />
      </div>
      <div className="back-icon">
        <PiKeyReturnFill size={40} onClick={() => navigate(`/tournaments/${slug}`)} />
      </div>

      <h3>{mode === "create" ? "➕ הוספת אירוע" : "✏️ עריכת אירוע"}</h3>

      <form onSubmit={handleSubmit} className="form-grid">
        <label>
          שם האירוע:
          <input name="name" value={form.name} onChange={handleChange} required />
        </label>

        <label>תאריך התחלה:
          <input type="date" name="startDate" value={form.startDate} onChange={handleChange} required />
        </label>

        <label>תאריך סיום:
          <input type="date" name="endDate" value={form.endDate} onChange={handleChange} required />
        </label>

        <label>
          פלייר:
          <input type="file" accept="image/*" onChange={onFlyerChange} />
          {flyerPreview && (
            <img src={flyerPreview} className="preview" alt="flyer" />
          )}
        </label>

        <label>
          קישור הרשמה:
          <input name="registrationLink" value={form.registrationLink} onChange={handleChange} />
        </label>

        <label>
          קישור פייסבוק:
          <input name="facebookLink" value={form.facebookLink} onChange={handleChange} />
        </label>

        <label>
          גלריה:
          <input type="file" accept="image/*" multiple onChange={onGalleryChange} />
          {gallery.length > 0 && (
            <div className="preview-grid">
              {gallery.map((g, i) => (
                <div key={i} className="thumb">
                  <img src={g.src} alt="" />
                  <button type="button" onClick={() => removeGalleryItem(i)}>הסרה</button>
                </div>
              ))}
            </div>
          )}
        </label>

        <div className="checkbox-group">
          {checkboxes.map(c => (
            <label key={c.name}>
              <input type="checkbox" name={c.name} checked={form[c.name]} onChange={() => toggleCheckbox(c.name)} />
              {c.label}
            </label>
          ))}
        </div>

        <div className="buttons">
          <button type="submit">💾 שמירה</button>
          <button type="button" onClick={handleDelete} className="delete">🗑️ מחיקת אירוע</button>
          <button type="button" onClick={() => navigate(`/tournaments/${slug}`)}>⬅️ חזרה</button>
        </div>
      </form>
    </div>
  );
};

export default EventForm;